<template lang='pug'>
  div
    transition(name='slide-fade-down' appear mode='out-in')
      ods-tabs(v-model='tabsCruises' @tab-click="handleClick")
        ods-tab-pane(v-for='(item, index) in dataTabsCruises' :name="item.name" :label='$t(item.label)' :key='index')
    transition(name='slide-fade-down' mode='out-in' appear)
      MapToolsGeneric(ref='toolsGeneric' @updateFilter='updateFilter' verticalType="cruises" v-show="false")
    //- keep-alive
    //-   router-view(
    //-     ref='cruises'
    //-     @controlCruisesRealTimeService='controlCruisesRealTimeService'
    //-   )
    transition(name='fade')
      LegendMap(:verticalType='tabsVertical' :dataLengend='listCruises[tabsVertical].legend' :datosFinal='dataParkingPanels2' :dataParkingCurrent='dataParkingCurrent' ref="legendMap")
    //- LegendMapIcon(:datosLegend='datosPopup' ref='LegendIcon' @open='open=true')

    //- transition(name='fade')
    //-   PopupBus(v-if='opened' :datosFinal='datosPopupBus')
    //- transition(name='slide-fade-down' mode='out-in' appear)
    //-   MapToolsGeneric(ref='toolsGeneric' @updateFilter='updateFilter' v-show='false')
    //- transition(name='fadeSlide' appear)
    //-   PanelDashboard(ref="panelDashboard" v-show='tabWithoutMap')
    //-     VerticalGeneric(slot="container"
    //-     ref='verticalGeneric'
    //-     @updateKpiGeneric='updateKpiGeneric'
    //-     verticalType='cruises'
    //-     @setPopupVehicle='setPopupVehicle')
    //-     MapZoomParks.panel-dashboard__tools.panel-dashboard__tools--bottom-left-out(
    //-       slot="tools"
    //-       ref='mapZoom'
    //-       )
    transition(name='fadeSlide' appear)
      PanelDashboard(ref="panelDashboard")
        VerticalGeneric(
          slot="container"
          ref='verticalGeneric'
          @updateKpiGeneric='updateKpiGeneric'
          verticalType='cruises'
          @setPopupBusLine='setPopupBusLine'
          @setPopupParking='setPopupParking')
        MapZoomParks.panel-dashboard__tools.panel-dashboard__tools--bottom-left-out(
          slot="tools"
          ref='mapZoom')
        SearchMap.panel-dashboard__search.panel-dashboard__search--top-left-out(
          slot="search"
          ref="mapSearch"
        )
</template>

<script>
import MapZoomParks from '@/components/MapZoomParks'
import PanelDashboard from '@/components/PanelDashboard'
import MapToolsGeneric from '@/components/MapToolsGeneric'
import VerticalGeneric from '@/views/VerticalGeneric'
import PopupPanelParking from '@/components/PopupPanelParking'
import PopupBus from '@/components/PopupBus'
import LegendMap from '@/components/LegendMap'
import SearchMap from '@/components/SearchMap'

import jsonGisCruises from '@/moks/las_palmas/cruises/gisCruises'
// import SockJS from 'sockjs-client'
// import Stomp from 'webstomp-client'
export default {
  name: 'CruisesMain',
  data () {
    return {
      realTime: null,
      tabsCruises: '',
      mapLoad: false,
      /**  Data para las respuestas de los servicios de parking */
      // contServiceCruisesRealTime: 0,
      // contServiceAutobuses: 0,
      // contServiceBike: 0,
      dataParkingSensorZones: [],
      dataParkings: [],
      datosFinal: [],
      dataParkingPanels: [],
      dataBike: [],
      tabWithoutMap: true,
      datosPopupBus: [],
      opened: false,
      // datosPopup: {
      //   name: 'Leyenda',
      //   img: 'Flotas',
      //   ico: 'ico_complaint_blue',
      //   primary: 'primary',
      //   textColorPrimary: 'Adecuado',
      //   medium: 'medium',
      //   textColorMedium: 'Alerta nivel medio',
      //   alert: 'alert',
      //   textColorAlert: 'Alerta nivel alto',
      //   component: 'CruisesMain'
      // },
      /** Pestañas con los subverticales de Flotas. */
      dataTabsCruises: [
        {
          name: 'CruisesRealTime',
          value: 'CruisesRealTime',
          label: 'Real Time',
          breadcumb: 'Tiempo Real'
        }
        // {
        //   name: 'CruisesHistoric',
        //   value: 'CruisesHistoric',
        //   label: 'Historic',
        //   breadcumb: 'Histórico'
        // }
      ],
      // received_messages: [],
      dataParkingPanels2: {},
      dataParkingCurrent: {},
      datosPopupBusLine: [],
      datosPopupParking: [],
      tabsVertical: 'Cruises',
      listCruises: {
        Cruises: {
          name: 'CruisesRealTime',
          value: 'CruisesRealTime',
          label: 'Real Time',
          breadcumb: 'Tiempo Real',
          listCategory: [
            {
              value: 'dataSourceFleetRealTime',
              label: 'Flotas',
              show: true
            }
          ],
          listCategorySelected: ['dataSourceFleetRealTime'],
          legend: {
            name: 'Leyenda',
            img: 'Flotas',
            ico: 'ico_complaint_blue',
            primary: 'primary',
            textColorPrimary: 'Adecuado',
            medium: 'medium',
            textColorMedium: 'Alerta nivel medio',
            alert: 'alert',
            textColorAlert: 'Alerta nivel alto',
            component: 'CruisesMain'
          }
        }
      }
    }
  },
  computed: {
    /** Función que optiene la ontología de zonas de sensores */
    // getCruiseRealTimeGisData () {
    //   //return this.$store.getters.getCruiseRealTimeGisData
    // }
  },
  watch: {
    // getCruiseRealTimeGisData (val) {
    //   const component = this
    //   if (val.features) {
    //     this.dataCruiseRealTime = val
    //     this.dataCruiseRealTime.name = 'FleetRealTime'
    //     var myLoadMapElem = setInterval(myLoadMap, 500)
    //     function myLoadMap () {
    //       if (component.mapLoad === true) {
    //         component.myTimerCruiseRealTime()
    //         clearInterval(myLoadMapElem)
    //         // component.contServiceAutobuses++
    //         // component.controlAutobusesService()
    //       }
    //     }
    //   } else {
    //     // component.contServiceAutobuses++
    //     // this.controlAutobusesService()
    //   }
    // }
  },
  methods: {
    init () {
      const vm = this
      var myLoadMap = () => {
        let encontrado = false
        if (vm.mapLoad === true) {
          document.getElementById('dataIframe').contentWindow.mapClear()
          let selectArray = vm.listCruises[vm.tabsVertical].listCategory
          selectArray.forEach(elem => {
            // 'dataSourceSensorZones', 'dataSourceParking', 'dataSourcePanelParking'
            document.getElementById('dataIframe').contentWindow.viewer.dataSources._dataSources
              .filter((data) => data._name.name === elem.value)
              .map((valor) => {
                valor.show = true
                encontrado = true
                return valor
              })
          })
          if (!encontrado) {
            vm.myTimerCruiseRealTime()
            // vm.createLayerGIs('sensorZones', jsonGisSensorZone)
            // vm.createLayerGIs('parking', jsonGisParking)
            // vm.createLayerGIs('panelParking', jsonGisPanelParking)
            // vm.createLayerGIs('busStop', jsonGisBusStop)
            // vm.createLayerGIs('busLine', jsonGisBusLine)
            // vm.createLayerGIs('busRealTime', jsonGisBusRealTime)
            // vm.createLayerGIs('bike', jsonGisBike)
          }
          vm.controlPage()
          clearInterval(myLoadMapElem)
        }
      }
      var myLoadMapElem = setInterval(myLoadMap, 500)
    },
    controlPage () {
      const component = this
      this.$refs.toolsGeneric.clearFilter()
      /*
      switch (this.$route.name) {
        case 'AutobusesDashboard':
          this.updateBusRealTime(true)
          this.tabsMobility = 'Autobuses'
          break
        case 'ParkingDashboard':
          this.updateBusRealTime(false)
          this.tabsMobility = 'Parking'
          break
        case 'BikeDashboard':
          this.updateBusRealTime(false)
          this.tabsMobility = 'Bike'
          break
      }
      */
      component.cleanAndLoadDataGis()
    },
    updatePopup (data) {
      this.datosFinal = data
      // this.opened = true
    },
    controlCruisesRealTimeService () {
      var TOTALCRUISESREALTIME = 1
      if (this.contServiceCruisesRealTime === TOTALCRUISESREALTIME) {
        this.controlPage()
      }
    },
    setMapLoad () {
      this.mapLoad = true
      // this.$refs.mapSearch.changeBasemap()
    },
    changeCategory (category) {
      this.$emit('changeCategory', category)
    },
    changeSelectedKpi (val) {
      this.$emit('changeSelectedKpi', val)
      this.$refs.park.updateControlSelected(val)
    },
    getStation (val) {
      this.$emit('getStation', val)
    },
    handleClick (tab, event) {
      this.$router.push({ name: this.tabsCruises + 'Dashboard' })
      this.controlPage()
      // Descomentar cuando necesitemos PopupPanelParking
      // if (document.getElementById('cesiumPopupPanelParking')) {
      //   document.getElementById('cesiumPopupPanelParking').style.display = 'none'
      // }
      // if(this.$refs.verticalGeneric) {
      // this.$refs.verticalGeneric.updateSelectedStation()
      // }
      // document.getElementById('dataIframe').contentWindow.resetEntityCards()
    },
    updateFilter (category, categorySelected) {
      // console.log('category' , category, categorySelected)
      this.$refs.cruises.setFilter(categorySelected, category)
      // this.$refs.verticalGeneric.dataSourceSelected
      this.$refs.verticalGeneric.updateKpis(category)
    },
    cleanAndLoadDataGis () {
      const component = this
      var category = []
      var categorySelected = []
      var myLoadMap = () => {
        if (component.mapLoad === true && component.$refs.toolsGeneric !== undefined) {
          document.getElementById('dataIframe').contentWindow.mapClear()
          category = component.listCruises[component.tabsVertical].listCategory
          categorySelected = component.listCruises[component.tabsVertical].listCategorySelected
          component.$refs.toolsGeneric.setToolsGeneric(
            category,
            categorySelected
          )
          component.loadDataFilter()
          component.$refs.verticalGeneric.updateKpis(categorySelected, component.tabsVertical)
          clearInterval(myLoadMapElem)
        }
      }
      var myLoadMapElem = setInterval(myLoadMap, 500)
    },
    loadDataFilter () {
      document.getElementById('dataIframe').contentWindow.activarDesactivarCapa(this.listCruises[this.tabsVertical].listCategory)
    },
    // cleanAndLoadDataGis () {
    //   const component = this
    //   var category = []
    //   var categorySelected = []
    //   function myLoadMap () {
    //     if (component.mapLoad === true) {
    //       document.getElementById('dataIframe').contentWindow.mapClear()
    //       category = component.$refs.cruises.getFilterCategory()
    //       categorySelected = component.$refs.cruises.getFilterCategorySelected()
    //       component.$refs.toolsGeneric.setToolsGeneric(
    //         category,
    //         categorySelected
    //       )
    //       component.$refs.cruises.loadDataFilter()
    //       // if(component.$refs.verticalGeneric) {
    //       component.$refs.verticalGeneric.updateKpis(categorySelected)
    //       // }
    //       clearInterval(myLoadMapElem)
    //     }
    //   }
    //   var myLoadMapElem = setInterval(myLoadMap, 500)
    // },
    controlCollapsePanel (open) {
      // if(this.$refs.panelDashboard) {
      this.$refs.panelDashboard.collapsePanel(open)
      // }
    },
    // controlPage () {
    //   // this.$refs.toolsGeneric.clearFilter()
    //   this.$refs.verticalGeneric.$refs.kpiVertical.kpiFilterSelected = ['all']
    //   switch (this.$route.name) {
    //     case 'CruisesRealTimeDashboard':
    //       this.$refs.toolsGeneric.clearFilter()
    //       this.cleanAndLoadDataGis()
    //       // document.getElementById('dataIframe').contentWindow.resetEntityCards()
    //       this.updateCruiseRealTime(true)
    //       this.tabWithoutMap = true
    //       this.tabsCruises = 'CruisesRealTime'
    //       break
    //     case 'CruisesHistoricDashboard':
    //       if (document.getElementById('dataIframe').contentWindow) {
    //         document.getElementById('dataIframe').contentWindow.resetEntityCards()
    //       }
    //       this.updateCruiseRealTime(false)
    //       this.opened = false
    //       this.tabWithoutMap = false
    //       this.tabsCruises = 'CruisesHistoric'
    //       break
    //   }
    //   // component.cleanAndLoadDataGis()
    // },
    myTimerCruiseRealTime  () {
      // const component = this
      let simb = 'img/icon_float_blue.svg'
      let simbSelect = 'img/icon_float_white.svg'
      let simbIsolated = 'ods-icon-icon_floats_isolated'
      // console.log('updateBus')
      // console.log('cochesss--------->', component.dataCruiseRealTime);

      if (document.getElementById('dataIframe').contentWindow) {
        document.getElementById('dataIframe').contentWindow.createLayer(
          jsonGisCruises,
          'cruiseRealTime',
          'point',
          'entity',
          'billboard',
          simb,
          simbSelect,
          simbIsolated,
          0.8
        )
      }
    },
    updateKpiGeneric () {
      const component = this
      var categorySelected
      component.$refs.toolsGeneric.getDataCategory()
      categorySelected = component.$refs.toolsGeneric.getCaterogySelected()
      component.$refs.verticalGeneric.updateKpis(categorySelected)
    },
    updateCruiseRealTime (param) {
      // const component = this
      // cuando los datos sean reales se cargara....
      // if(param) {
      //   this.realTime = setInterval(function () {
      //     component.$store.dispatch('getCruiseRealTimeData')
      //   }, 1500)
      // } else {
      //   clearInterval(this.realTime)
      // }
    },
    setPopupBusLine (val, data) {
      this.datosPopupBusLine = []
      this.opened = val
      this.datosPopupBusLine = data
      let patron = /0+/
      let separado = this.datosPopupBusLine.name.split('_', 2)
      var linea = separado[0].replace(patron, '')
      this.datosPopupBusLine.nameLine = linea
    },
    setPopupParking (val, data, type, currentKpi) {
      this.$refs.legendMap.open = this.$refs.legendMap.data = true
      this.openedParking = val
      this.dataParkingPanels = []
      this.dataParkingPanels = data
      this.dataParkingPanels2 = data
      this.dataParkingCurrent = currentKpi
    },
    setPopupVehicle (val, data) {
      this.opened = val
      this.datosPopupBus = data
    },
    pagLegend () {
      // $route.name == 'CRM'
      console.log(this.$route.matched[0].name)
    }
    // connectWS () {
    //   const component = this
    //   this.socket = new SockJS(process.env.SERVICES_PROVIDER + '/ws')
    //   this.stompClient = Stomp.over(this.socket)
    //   this.stompClient.connect({}, (frame) => {
    //     this.stompClient.subscribe('/topic/public', (tick) => {
    //       var data = JSON.parse(tick.body)
    //       data.date = data.timestamp
    //       component.received_messages.push(data)
    //       console.log('Conectado')
    //       // if (component.received_messages.length > 0) {
    //       //   component.isHidden = false
    //       // }
    //     })
    //   }, (error) => {
    //     console.log(error)
    //     console.log('Reconectando')
    //     this.connectWS()
    //   })
    // }
  },
  mounted () {
    // this.$store.dispatch('getCruiseRealTimeData')
    // if(document.getElementById('dataIframe').contentWindow) {
    // this.updateCruiseRealTime(true)
    // }
    // this.connectWS()
    this.init()
  },
  beforeRouteLeave (to, from, next) {
    this.updateCruiseRealTime(false)
    next()
  },
  beforeDestroy () {
    document.getElementById('dataIframe').contentWindow.mapClear()
  },
  components: {
    MapZoomParks,
    PanelDashboard,
    MapToolsGeneric,
    VerticalGeneric,
    PopupPanelParking,
    PopupBus,
    LegendMap,
    SearchMap
  }
}
</script>

<style lang='scss' scoped>
/deep/ .ods-tabs {
  z-index: 9999999;
  &__nav-wrap.is-scrollable {
    padding: 0 rem(48);
    width: 88%;
  }
  &__header {
    box-sizing: border-box;
    background: $--color-white;
    margin-bottom: 0;
    min-height: rem(54);
    padding: rem(12) rem(32) rem(0);
    z-index: 2;
  }

  &__item {
    padding: rem(16) rem(24);
  }
}
.panel-dashboard__legend_icon{
    position: absolute;
    left: 0px;
    bottom: 0px;
    z-index: 2;
    padding: 7px;
}
</style>



// WEBPACK FOOTER //
// src/views/CruisesMain.vue